module.exports = __webpack_public_path__ + "static/media/cat-countdown.da8c3425.gif";